import { inject as service } from '@ember/service';
import ApplicationAdapter, { Payload } from 'cio/adapters/application';
import EnvironmentService from 'cio/services/environment';
import DS from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class ShortSegmentAdapter extends ApplicationAdapter {
  @service environment!: EnvironmentService;

  urlForFindAll(_modelName: keyof ModelRegistry, snapshot: DS.SnapshotRecordArray<keyof ModelRegistry>): string {
    return `${super.urlForFindAll('segment', snapshot)}?short=1`;
  }

  handleResponse(status: number, headers: Record<string, any>, payload: Payload, requestData: Record<string, any>) {
    let updatedPayload: Record<string, any> = {};

    if (typeof payload === 'object' && 'segments' in payload) {
      updatedPayload['short-segments'] = payload.segments;
    }

    return super.handleResponse(status, headers, updatedPayload, requestData);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    'short-segment': ShortSegmentAdapter;
  }
}
